import React, { useState, useEffect } from 'react';
import { Pool } from '../types';
import { apiService, formatters } from '../services/api';

interface PoolsPageProps {
  onPoolSelect: (poolId: string) => void;
}

const PoolsPage: React.FC<PoolsPageProps> = ({ onPoolSelect }) => {
  const [pools, setPools] = useState<Pool[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadPools();
  }, []);

  const loadPools = async () => {
    try {
      setLoading(true);
      const poolData = await apiService.getPools();
      setPools(poolData);
    } catch (error) {
      console.error('Error loading pools:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading"></div>
        <p>Loading pools...</p>
      </div>
    );
  }

  return (
    <div className="pools-page">
      <h2>All Pools</h2>
      <div className="pools-table-container">
        <table className="pools-table">
          <thead>
            <tr>
              <th>Pool</th>
              <th>Algorithm</th>
              <th>Hashrate</th>
              <th>Miners</th>
              <th>Fee</th>
              <th>Last Block</th>
            </tr>
          </thead>
          <tbody>
            {pools.map(pool => (
              <tr key={pool.id} onClick={() => onPoolSelect(pool.id)} style={{ cursor: 'pointer' }}>
                <td>{pool.coin}</td>
                <td>{pool.algorithm}</td>
                <td>{formatters.hashrate(pool.hashrate)}</td>
                <td>{pool.minerCount}</td>
                <td>{formatters.percentage(pool.fee)}</td>
                <td>{pool.lastBlock ? formatters.timeAgo(pool.lastBlock.timestamp) : 'Never'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PoolsPage;